<template>
  <div class="homePage">
    <!-- 顶部用户 -->
    <div class="homePageTop">
      <div class="homePageTopBox">
        <div class="homePageTopImg">
            <img v-if="$store.state.userMessages.headUrl == null" src="../../assets/users.png" alt="" />
            <img v-if="$store.state.userMessages.headUrl != null" :src="$store.state.userMessages.headUrl" alt="" />
        </div>
        <div class="homePageTopTille">
          <h3>{{ $store.state.userMessages.name }}<el-button @click="handleDesigner">
              <i class="iconfont icon-dianpu"></i>进店</el-button>
          </h3>
          <div class="homePageTopTillemess">
            <p @click="jumpOthers('adr')">个人信息</p>
            <span>|</span>
            <p @click="jumpOthers('accountManagement')" v-if="!existsShow">账户设置</p>
            <p @click="jumpOthers('accountManagement')" v-if="existsShow">查看账户信息</p>
            <span v-if="designer.type != 'BOTH'">|</span>
            <p  v-if="designer.type == 'GRAPHIC'" @click="jumpOthers('model')" style="cursor: initial">您还可以申请为 <span style="cursor: pointer;">三维设计师</span> </p>
            <p  v-else-if="designer.type == 'MODEL'" @click="jumpOthers('graphic')" style="cursor: initial">您还可以申请为 <span style="cursor: pointer;">平面设计师</span> </p>
          </div>
        </div>
      </div>

      <div class="homePageTopMess">
        <div class="homePageTopMessBox">
          <p>已报价</p>
          <p class="homePageTopMessBoxNum">{{ payment }}</p>
        </div>
        <i></i>
        <div class="homePageTopMessBox">
          <p>待设计</p>
          <p class="homePageTopMessBoxNum">{{ delivery }}</p>
        </div>
        <i></i>
        <div class="homePageTopMessBox">
          <p>设计待确认</p>
          <p class="homePageTopMessBoxNum">{{ thegoods }}</p>
        </div>
        <i></i>
        <div class="homePageTopMessBox">
          <p>待评价</p>
          <p class="homePageTopMessBoxNum">{{ evaluation }}</p>
        </div>
      </div>
    </div>
    <!-- 下半部分 -->
    <div class="homePageBottom">
      <!-- 左边 -->
      <div class="homePageBottomL">
        <!-- 我的订单 -->
        <div class="homeBottonL">
          <div class="homeBottonLTitle">
            <p>我的订单</p>
            <span @click="jumpOthers('order')">全部订单</span>
          </div>
          <div class="homeBottonLTitleBox">
            <div style="text-align:center" v-if="tabsList.lenth==0">
                <img src="../../assets/images/暂无订单.jpg" alt="" style="width:200px">
            </div>
            <div class="myOrderList" v-for="(tabsItems,index) in tabsList" :key="index">
                <div class="myOrderList_box">
                    <div class="myOrderList_box_mess">
                        <h4 style="cursor: pointer" @click="onClickOrderDetails(tabsItems.uuid)">{{tabsItems.demandName}}</h4>
                        <div class="myOrderList_box_messText">
                            <p>{{tabsItems.designerName}}</p>
                            <span></span>
                            <p>{{tabsItems.planDeliveryTime}}</p>
                            <span></span>
                        </div>
                    </div>
                </div>
                <p class="myOrderList_money">￥{{tabsItems.offerPrice}}</p>
                <p class="myOrderList_state">{{tabsItems.designStatusCn}}</p>
                </div>
            </div>
        </div>
        <!-- 热销作品TOP10 -->
        <div class="homeBottonL">
          <div class="homeBottonLTitle">
            <p>热销作品TOP10</p>
            <span @click="jumpOthers('hot')">全部作品</span>
          </div>
          <div class="collection">
            <div
              class="collectionBox"
              v-for="(collect, index) in collectionList"
              :key="index"
            >
              <img :src="collect.imgUrl" alt="">
              <div class="collectionBox_text">
                  <p class="collectionBox_textOn"><a :href="$url.threeWeb+'/modelDetails?uuid='+collect.uuid" target="_blank">{{collect.modelName}}</a></p>
                  <p class="collectionBox_textP">
                      <i class="el-icon-download"></i>
                      <span>{{collect.downNum}}</span>
                  </p>
              </div>
              <p class="collectionBox_Mess">模型</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 右边 -->
      <div class="homePageBottomR">
        <!-- 交易概况 -->
        <div class="homeBottonR">
          <div class="homeBottonLTitle">
            <p>交易概况</p>
          </div>
          <div class="designerFocus">
              <div class="designerFocus_num">
                  <p>
                      完成订单： <span>{{allOrderInfo.ALLCount}}</span> 笔
                  </p>
                   <p>
                      成交额： <span>{{allOrderInfo.ALLPrice}}</span> 元
                  </p>
              </div>
              <div class="designerFocusMess_box">
                <div class="designerFocusMess" >
                    <p>参与报价订单数</p>
                    <h4>{{ allOrderInfo.designerCount }}</h4>
                </div>
                  <div class="designerFocusMess">
                      <p>完成设计订单数</p>
                      <h4>{{ allOrderInfo.desingerOrderCount }}</h4>
                  </div>
                  <div class="designerFocusMess">
                      <p>作品数</p>
                      <h4>{{ allOrderInfo.modelCount }}</h4>
                  </div>
                  <div class="designerFocusMess">
                      <p>设计成交额</p>
                      <h4>{{ allOrderInfo.desingerOrderPrice }}</h4>
                  </div>
              </div>
          </div>
        </div>
        <!-- 推荐需求 -->
        <div class="homeBottonR">
          <div class="homeBottonLTitle">
            <p>推荐需求</p>
            <span><a href="https://www.zengcaicloud.com/designList" target="_blank">更多</a></span>
          </div>
          <div class="shopFocus">
            <div
              class="shopFocusBox"
              v-for="(shopFocus, index) in shopFocusList"
              :key="index"
            >
              <div class="shopFocusBoxNum">
                <div class="shopFocusBoxMess">
                  <p style="cursor: pointer"><a :href="$url.threeWeb+'/designDetails/'+shopFocus.uuid" target="_blank">{{ shopFocus.demandName }}</a></p>
                  <div class="shopFocusBoxMess_p">
                      <div class="shopFocusBoxMess_pMo">
                          <span class="shopFocusBoxMess_pMo1">预算</span>
                          <span class="shopFocusBoxMess_pMo2">{{ shopFocus.lowPreAmount }}-{{shopFocus.highPreAmount }}</span>
                      </div>
                      <span>期望交期：{{ shopFocus.expectedDeliveryTime }}</span>

                  </div>
                </div>
              </div>
              <i class="iconfont">&#xe602;</i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 文字部分 -->
    <div class="textMess">
      <p>
          <span style="cursor: pointer" @click="goThreeWEB('main')">帮助</span>
          <span style="cursor: pointer" @click="goThreeWEB('ZCYYHYSXY')">隐私</span>
          <span style="cursor: pointer" @click="goThreeWEB('main')">条款</span>
      </p>
      <p>copyright@2021 安徽增材云数字科技有限公司</p>
    </div>
    <!-- 账号管理 -->
    <AccountSet ref="accountSetRef"/>
    <!-- 三维设计师认证 -->
    <Rcertification ref="modelDesignerCertification"/>
      <!-- 平面设计师认证 -->
    <Gcertification ref="graphicDesignerCertification"/>
  </div>
</template>

<script>
import {merchantExists,designerByUserId, findAllDesignList, getDesignOrderCount, getModelList,demandListByPage,getAllDesignOrderInfo, getNewcurrent} from "../../utils/interface";
import AccountSet from "./accountSet.vue";
import Rcertification from "./rcertification.vue";
import Gcertification from "./graphicCertification.vue";

export default {
  name: "homePage",
  data() {
    return {
      // 顶部用户
      payment: 0,
      delivery: 0,
      thegoods: 0,
      evaluation: 0,
      //热销
      collectionList: [],
      //   关注店铺
      shopFocusList: [],
      tabsList: [],
      allOrderInfo:{
        designerCount:0,
        desingerOrderCount:0,
        desingerOrderPrice:0,
        ALLCount:0,
        ALLPrice:0,
        modelCount:0,
      },
      designer:{},
      userMessages:{},
      existsShow: false
    };
  },
  components:{
    AccountSet,
    Rcertification,
      Gcertification,
  },
  created(){
      getNewcurrent()
          .then((res) => {
              this.userMessages = res;
              // 查询设计师信息
              designerByUserId(this.userMessages.uuid).then((res) => {
                  this.designer = res;
              });
          })
          .catch((err) => {
              console.log(err);
          });
      // 获取设计订单
      this.findAllDesignList();
      // 获取订单数量
      this.getDesignOrderCount();
      // 热销
      this.getModelList();
      this.getDemandList();
      this.findAllDesignOrderInfo();
      this.getMerchantExists()
  },
  methods: {
    getMerchantExists(){
        merchantExists().then(res => {
            if(res.success){
                this.existsShow = res.data
            }else {
                this.$message.error(res.message);
            }
        })
    },
    onClickOrderDetails(uuid){
        this.$emit('hompageLog','order')
      this.$router.push({name:'designOrderDetail',params:{uuid:uuid}})
    },
      getDesignOrderCount(){
          getDesignOrderCount().then((res)=> {
              if (res && res.data) {
                  this.payment = res.data.payCount != null ? res.data.payCount : 0;
                  this.delivery = res.data.designCount != null ? res.data.designCount : 0;
                  this.thegoods = res.data.confirmCount != null ? res.data.confirmCount : 0;
                  this.evaluation = res.data.appraiseCount != null ? res.data.appraiseCount : 0;
              }
          });
      },
      findAllDesignList(){
          findAllDesignList({isBuy:false}).then((res)=>{
              if(res&&res.length>4){
                  this.tabsList = res.slice(0,4);
              }else {
                  this.tabsList = res
              }
          });
      },
    // 跳转路由
    jumpOthers(type){
      if(type == 'adr'){
        this.$router.push('/storeMessage')
        this.$emit('hompageLog','adr')
      }else if (type == 'user'){
        this.$refs.accountSetRef.init()
      }else if(type =='order'){
          this.$router.push('/designOrderList')
          this.$emit('hompageLog','order')
      }else if(type =='hot'){
          this.$router.push('/modelManagement')
          this.$emit('hompageLog','hot')
      }else if(type =='model'){
        this.$refs.modelDesignerCertification.init()
      }else if(type =='graphic'){
          this.$refs.graphicDesignerCertification.init()
      }else if(type == 'accountManagement'){
        this.$router.push('/accountManagement')
        this.$emit('hompageLog','accountManagement')
      }
    },
    handleDesigner(){
        designerByUserId(this.$store.state.userMessages.uuid).then((res) => {
            if(res){
                window.open(
                    this.$url.threeWeb + '/designModel/' + res.uuid ,
                    "_blank"
                );
            }
        })

    },
      getModelList() {
          // if(this.$store.state.userMessages == null ||!this.$store.state.userMessages.user_uuid  ){
          //     alert("请先登录！");
          //     this.$router.push({name: "login"});
          //     return;
          // }
          let params = {
              isLogin: 2,
              orderBy: "DOWNLOAD",
              status: "RELEASED",
          };
          getModelList(params).then((res) => {
              if(res.list.length>0){
                  res.list.forEach((val)=> {
                        if(val.downNum>0){
                            this.collectionList.push(val);
                        }
                  })
              }
              // this.collectionList = res.list;
          });
      },
      getDemandList() {
          // if(this.$store.state.userMessages == null ||!this.$store.state.userMessages.user_uuid  ){
          //     alert("请先登录！");
          //     this.$router.push({name: "login"});
          //     return;
          // }
          let params = {
              isLogin: 1,
              status: "PASS",
          };
          demandListByPage(params).then((res) => {
              if(res.list.length>5){
                  this.shopFocusList = res.list.slice(0,5);
              }else {
                  this.shopFocusList = res.list;
              }

          });
      },
      findAllDesignOrderInfo(){
          getAllDesignOrderInfo().then((res) => {
              if(res.success){
                  this.allOrderInfo = res.data
              }
          });
      },
      goThreeWEB(type){
          if(type=="main"){
              window.open(
                  this.$url.threeWeb + '/helpCenter',
                  "_blank"
              );
          }else {
              window.open(
                  this.$url.threeWeb + '/helpCenterDetail?wordNo=ZCYYHYSXY',
                  "_blank"
              );
          }

      }
  }
};
</script>

<style scoped  lang="less">
p,
h3 {
  margin: 0;
}
.homePage {
  padding: 20px;
  // 顶部用户
  .homePageTop {
    box-shadow: 0px 0px 5px rgb(228 228 228);
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 1);
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 60px;
    margin-bottom: 20px;
    .homePageTopBox {
      display: flex;
    }
    .homePageTopImg {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      margin-right: 20px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .homePageTopTille {
      h3 {
        font-size: 20px;
        font-weight: 400;
        margin-bottom: 10px;
        button{
            margin-left: 10px;
            padding: 5px 10px;
            font-size: 12px;
            border-radius: 20px;
            i{
                vertical-align: text-bottom;
                padding-right: 5px;
            }
        }
      }
      .homePageTopTillemess {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.427);
        display: flex;
        align-items: center;
        span {
          margin: 0 10px;
        }
        p {
          cursor: pointer;
          span {
            color: #1890ff;
          }
        }
      }
    }
    .homePageTopMess {
      display: flex;
      align-items: center;
      .homePageTopMessBox {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.427);
        text-align: center;
        width: 130px;
        .homePageTopMessBoxNum {
          font-weight: 700;
          font-size: 20px;
          color: rgb(57, 119, 243);
          cursor: pointer;
        }
      }
      i {
        display: inline-block;
        width: 1px;
        height: 30px;
        background: rgb(223, 223, 223);
      }
    }
  }
  //   下半部分
  .homePageBottom {
    display: flex;
    // 左边
    .homePageBottomL {
      margin-right: 20px;
      width: 65%;

      .homeBottonL {
        box-shadow: 0px 0px 5px rgb(228 228 228);
        border-radius: 5px;
        background-color: rgba(255, 255, 255, 1);
        margin-bottom: 20px;
        .homeBottonLTitle {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          border-bottom: 1px solid #efefef;
          padding: 15px 30px;
          p {
            font-weight: 700;
          }
          span {
            color: rgb(24, 144, 255);
            cursor: pointer;
          }
        }
        // 我的订单
        .homeBottonLTitleBox {
          padding: 30px;
          padding-top: 10px;
          height: 334px;
          overflow-y: auto;
           ::-webkit-scrollbar {
              /*隐藏滚轮*/
              display: none !important;
            }
          .homeBottonLTitleBox_tab {
            display: flex;
            align-items: center;
            i {
              font-style:normal
            }
          }
          .myOrderList {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            padding: 15px;
            border-bottom: 1px solid #efefef;
            &:nth-last-child(1){
                border-bottom: 0;
            }
            .myOrderList_box {
              display: flex;
              align-items: center;
              width: 250px;
              img {
                width: 50px;
                height: 50px;
                border-radius: 6px;
                margin-right: 6px;
              }
              .myOrderList_box_mess {
                h4 {
                  font-size: 14px;
                  margin: 0;
                }
                .myOrderList_box_messText {
                  display: flex;
                  align-items: center;
                  margin-top: 6px;
                  p {
                    font-size: 12px;
                    color: #727272;

                  }
                  span {
                    margin: 0 6px;
                    display: inline-block;
                    width: 1px;
                    height: 12px;
                    background: #b1b1b1;
                  }
                }

              }
            }
            .myOrderList_money {
              font-weight: bold;

            }
            .myOrderList_state {
              color: #1890ff;
              width: 100px;
              text-align: right;
            }
          }

        }
        // 我的收藏
        .collection {
          padding: 20px 30px 10px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          .collectionBox {
            width: 18%;
            border: 1px solid #efefef;
            margin-right: 20px;
            margin-bottom: 20px;
            position: relative;
            &:nth-of-type(5n + 5) {
              margin-right: 0;
            }
            img {
                width: 100%;
                height: 104px;
            }
            .collectionBox_text {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin: 10px 6px 0;
                p {
                    font-size: 14px;
                }
                .collectionBox_textOn {
                    width: 60%;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    a {
                      color: #000;
                      &:hover {
                        color: #1890ff;
                      }
                    }
                }
                .collectionBox_textP {
                    border: 1px solid #1890ff;
                    color: #1890ff;
                    border-radius: 6px;
                    padding: 0 5px;
                }
            }
            .collectionBox_Mess {
                margin: 4px 6px 10px;
                color: #727272;
                font-size: 12px;
            }
          }

        }
      }
    }
    // 右边
    .homePageBottomR {
      width: 35%;
      .homeBottonR {
        box-shadow: 0px 0px 5px rgb(228 228 228);
        border-radius: 5px;
        background-color: rgba(255, 255, 255, 1);
        margin-bottom: 20px;
        .homeBottonLTitle {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          border-bottom: 1px solid #efefef;
          padding: 15px 30px;
          p {
            font-weight: 700;
          }
          span {
            color: rgb(24, 144, 255);
            cursor: pointer;
          }
        }
        // 交易概况
        .designerFocus {
        //   display: flex;
        //   align-items: center;
        //   height: 130px;
            .designerFocus_num {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 40px 0;
                color: #3977f3;
                span {
                    font-size: 27px;
                    font-weight: 500;
                }
                p:nth-of-type(1) {
                    margin-right: 60px;
                }

            }
            .designerFocusMess_box {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                justify-content: center;
                .designerFocusMess {
                    width: 40%;
                    border-radius: 10px;
                    margin-bottom: 40px;
                    padding: 10px 20px;
                    color: #fff;
                    h4 {
                        margin: 0;
                        font-size: 30px;
                    }
                    img {
                        width: 47px;
                        height: 40px;
                        border-radius: 50%;
                    }
                    p {
                        font-size: 14px;
                    }
                    &:nth-of-type(2n+2){
                        margin-left: 40px;
                    }
                    &:nth-of-type(1){
                        background: #ed823e;
                    }
                    &:nth-of-type(2){
                        background: #cfb645;
                    }
                    &:nth-of-type(3){
                        background: #4db2f8;
                    }
                    &:nth-of-type(4){
                        background: #48a039;
                    }
                }
            }

        }
        // 推荐需求
        .shopFocus {
          .shopFocusBox {
            display: flex;
            align-items: center;
            justify-content: space-between;
            // height: 68px;
            border-bottom: 1px solid #efefef;
            margin: 0 30px;
            padding: 15px 0;
            .shopFocusBoxNum {
              display: flex;
              align-items: center;
              img {
                height: 40px;
                width: 44px;
                margin-right: 15px;
              }
              .shopFocusBoxMess {
                font-size: 14px;
                a {
                  color: #000;
                  &:hover {
                    color: #1890ff;
                  }
                }
                p {
                  margin-bottom: 5px;
                }
                .shopFocusBoxMess_p {
                    display: flex;
                    align-items: center;
                    margin-top: 8px;
                    justify-content: space-between;
                    width: 300px;
                    .shopFocusBoxMess_pMo {
                        // border: 1px solid #3977f3;
                        display: flex;
                        margin-right: 10px;
                        p {
                            margin-right: 16px;
                            margin-bottom: 0;
                        }
                        .shopFocusBoxMess_pMo1 {
                            background: #3977f3;
                            display: inline-block;
                            width: 30px;
                            height: 20px;
                            line-height: 20px;
                            color: #fff;
                            padding: 0 5px;
                            text-align: center;
                        }
                        .shopFocusBoxMess_pMo2 {
                            border: 1px solid #3977f3;
                            color: #3977f3;
                            padding: 0 20px;
                            height: 20px;
                            line-height: 20px;
                            box-sizing: border-box;
                        }

                    }
                    span {
                        font-size: 12px;
                    }

                }

              }
            }
            .iconfont {
              font-size: 30px;
              color: #cadbf7;
            }
          }
        }
      }
    }
  }
  //   文字部分
  .textMess {
    text-align: center;
    margin-top: 40px;
    p {
      font-size: 14px;
      margin-bottom: 15px;
      span {
        cursor: pointer;
        margin-right: 16px;
        &:nth-last-of-type(1) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/homePage.vue